import React from 'react';

interface Props {
  src: string;
  name?: string;
}

const PdfViewer: React.FC<Props> = ({ src, name }) => {
  return (
    <div>
      <iframe
        data-testid="pdf-viewer"
        title={name || 'pdf-viewer'}
        src={src + '#toolbar=0'}
        style={{ width: '100%', height: '90vh', border: 'none' }}
      />
    </div>
  );
};

export default PdfViewer;
